export function searchItemsInColumns<T, K extends keyof T>(
	data: Array<T>,
	searchedColumns: K[],
	searchValue: string
): Array<T> {
	return data.filter((item) =>
		searchedColumns.some((key) =>
			String(item[key])
				.toLowerCase()
				.includes(searchValue.toLowerCase())
		)
	);
}
